(() => {
  'use strict';
  const keys = ['oem', 'sourcing', 'trade', 'market-entry', 'digital', 'creative', 'other'];
  const fields = ['company', 'name', 'email', 'phone', 'body', 'service'];
  const storageKey = 'jinkou:contact:restore:v1';
  const ttl = 10 * 60 * 1000;
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const state = root.querySelector('[data-contact-state]')?.dataset.contactState;
    const scope = root.querySelector('.jkc-fields');
    const field = name => scope?.querySelector(`[name="contact[${name}]"]`);
    const consent = field('privacy_consent');
    if (consent) consent.checked = false;
    const clear = () => { try { sessionStorage.removeItem(storageKey); } catch (_) {} };
    if (state === 'success') { clear(); root.querySelector('[data-contact-state]').focus(); return; }
    const service = field('service');
    if (!service) return;
    scope.querySelectorAll('input,select,textarea').forEach(input => {
      input.addEventListener('invalid', () => input.setAttribute('aria-invalid', 'true'));
      input.addEventListener('input', () => {
        if (input.validity.valid) input.removeAttribute('aria-invalid');
      });
    });
    const query = new URLSearchParams(location.search).getAll('service');
    service.value = query.length === 1 && keys.includes(query[0]) ? query[0] : '';
    try {
      const raw = sessionStorage.getItem(storageKey);
      if (raw) {
        const saved = JSON.parse(raw);
        const age = Date.now() - saved.time;
        if (state === 'error' && age >= 0 && age < ttl && saved.fields) {
          fields.forEach(name => {
            const input = field(name), value = saved.fields[name];
            if (!input || typeof value !== 'string') return;
            if (name === 'service') input.value = keys.includes(value) ? value : '';
            else input.value = value.slice(0, input.maxLength > 0 ? input.maxLength : 5000);
          });
        }
        clear();
      }
    } catch (_) { clear(); }
    root.querySelector('[data-preview-check]')?.addEventListener('click', () => {
      const invalid = [...scope.querySelectorAll('input,select,textarea')].find(el => !el.checkValidity());
      if (invalid) { invalid.reportValidity(); return; }
      root.querySelector('[data-preview-result]').textContent = '入力形式を確認しました。プレビューのため送信は行っていません。';
    });
    const form = scope.tagName === 'FORM' ? scope : null;
    if (!form) return;
    let submitting = false;
    form.addEventListener('submit', event => {
      if (submitting) { event.preventDefault(); return; }
      if (!form.checkValidity()) return;
      // Let Shopify/hCaptcha process this native event first.
      queueMicrotask(() => {
        if (event.defaultPrevented) return;
        const values = {};
        fields.forEach(name => { values[name] = field(name)?.value || ''; });
        try { sessionStorage.setItem(storageKey, JSON.stringify({time: Date.now(), fields: values})); } catch (_) {}
        submitting = true;
        const button = form.querySelector('[type=submit]');
        if (button) { button.disabled = true; button.textContent = '送信中…'; }
      });
    });
    window.addEventListener('pageshow', () => {
      submitting = false;
      if (consent) consent.checked = false;
      const button = form.querySelector('[type=submit]');
      if (button) { button.disabled = false; button.textContent = '送信する'; }
    });
  }
  document.querySelectorAll('[data-jinkou-contact]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-jinkou-contact]').forEach(init));
})();
